import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function tradeHolidayList(data) {
  return axios.post(`${base.url}/business/tradeHoliday/list`, qs.stringify(data))
}

export function tradeHolidayDetail(id) {
  return axios.post(`${base.url}/business/tradeHoliday/detail`, qs.stringify({ id }))
}

export function tradeHolidayAddOrUpdate(data) {
  return axios.post(`${base.url}/business/tradeHoliday/addOrUpdate`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeHolidaySyncAll(data = {}) {
  return axios.post(`${base.url}/business/tradeHoliday/sync/all`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeHolidayDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/tradeHoliday/deleteBatchIds`, qs.stringify({ ids }))
}

export function tradeHolidayStatus(id, status) {
  return axios.post(`${base.url}/business/tradeHoliday/status`, qs.stringify({ id, status }))
}

export function tradeHolidayCreateOne(data) {
  return axios.post(`${base.url}/business/tradeHoliday/createOne`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeHolidayRetryCreate(data) {
  return axios.post(`${base.url}/business/tradeHoliday/retryCreate`, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' }
  })
}

export function tradeHolidayLogList(data) {
  return axios.post(`${base.url}/business/tradeHoliday/log/list`, qs.stringify(data))
}
